
import React, { useState } from 'react';
import {
    FormControl,
    Icon,
    ImagePicker
} from 'components';
import {
    faCheckCircle
} from '@fortawesome/fontawesome-pro-solid';
import { LOGOS } from 'lib/afterPayLogos'
import classNames from 'lib/classNames';

const AfterPaySelector = ({ shopContext }) => {
    const {
        state: { settings: { afterPay } },
        setItem
    } = shopContext
    const [uploadedImage, setUploadedImage] = useState(afterPay.isExternal ? afterPay.image : null)
    const handleImageSelect = (image, isExternal = true) => {
        setItem("settings.afterPay.image", image)
        setItem("settings.afterPay.isExternal", isExternal)
        if (isExternal) {
            setUploadedImage(image)
        }
    }

    const selectedImage = afterPay?.image
    return (
        <>
            <FormControl label='Select payment provider' isSingleCol={true}>
                <div className={classNames('flex flex-wrap ')} >
                    {
                        LOGOS.map(({ src, id, style }, key) => {
                            return (
                                <div key={key} className={classNames('relative')} >
                                    <div key={id} className={classNames('rounded-full flex justify-center items-center m-2 cursor-pointer overflow-hidden')} style={style} onClick={() => handleImageSelect(src, false)}>
                                        <img style={{ height: "25px" }} src={src} />
                                    </div>
                                    {selectedImage === src && <div className={classNames('absolute top-0 right-0')}> <Icon icon={faCheckCircle} color="#2f80ed" /> </div>}
                                </div>
                            )
                        })
                    }
                    {
                        !!uploadedImage &&
                        <div className={classNames('flex relative')}>
                            <div className={classNames('rounded-full flex justify-center items-center m-2 cursor-pointer overflow-hidden	')} onClick={() => handleImageSelect(uploadedImage, true)}>
                                <img style={{ height: "25px" }} src={uploadedImage} />
                            </div>
                            {selectedImage === uploadedImage && <div className={classNames('absolute top-0 right-0')}> <Icon icon={faCheckCircle} color="#2f80ed" /> </div>}
                        </div>
                    }
                </div>
                <div className={classNames('m-2')}>
                    <ImagePicker onChange={handleImageSelect} simplified={true} />
                </div>
            </FormControl>
        </>
    )

}

export default AfterPaySelector